module.exports = __webpack_public_path__ + "img/item2.970f438c.png";